import React, { useState, useEffect } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core";

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 5,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    // backgroundColor: 'red',
    backgroundImage: (props) =>
      props.progress == 100
        ? "linear-gradient(to right, #ef0505 , #ffafaf)"
        : "linear-gradient(to right, #690562 , #ff9cd8)",
    // backgroundImage: 'linear-gradient(to right, #690562 , #ff9cd8)'
  },
}))(LinearProgress);

const TimeCounter = ({ time }) => {
  let [hours, sethours] = useState(Math.floor(time.totalCurrentMinutes / 60));
  let [minutes, setminutes] = useState(
    Math.floor(time.totalCurrentMinutes % 60)
  );
  let [seconds, setseconds] = useState(0);
  let [progress, setprogress] = useState(
    JSON.parse(JSON.stringify(time.percentProgress))
  );
  let [MinutesProgress, setMinutesProgress] = useState(
    JSON.parse(JSON.stringify(time.totalCurrentMinutes))
  );

  useEffect(() => {
    if (MinutesProgress < time.totalMinutes) {
      setTimeout(() => {
        if (seconds + 1 == 60) {
          if (minutes + 1 == 60) {
            setminutes(0);
            sethours(hours + 1);
          } else {
            setminutes(minutes + 1);
          }
          setMinutesProgress(MinutesProgress + 1);
          setseconds(0);
        } else {
          setseconds(seconds + 1);
        }

        setprogress((MinutesProgress * 100) / time.totalMinutes);
      }, 1000);
    } else {
      setprogress(100);
    }
  }, [seconds]);

  return (
    <>
      <BorderLinearProgress
        progress={progress}
        variant="determinate"
        value={progress}
      />
      {hours + "h : " + minutes + "m elapsed"}
    </>
  );
};
export default TimeCounter;
